import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import { FlatMembership } from '../../../../types/membership.types';
import './DeleteMembership.scss';

interface DeleteMembershipProps {
  show: boolean;
  handleClose: () => void;
  membership: FlatMembership;
  onConfirm: () => void;
}

const DeleteMembership: React.FC<DeleteMembershipProps> = ({
  show,
  handleClose,
  membership,
  onConfirm,
}) => {
  const canDelete = membership.can_delete;

  return (
    <Modal show={show} onHide={handleClose} centered className="delete-membership-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          {canDelete ? 'Confirmar eliminación' : 'No se puede eliminar'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {canDelete ? (
          <div>
            <p>
              ¿Estás seguro de que deseas eliminar la membresía{' '}
              <strong>{membership.membership_name}</strong>?
            </p>
            {membership.next_membership_id && (
              <div className="warning-box" style={{ 
                background: '#fff3cd', 
                padding: '12px', 
                borderRadius: '8px', 
                marginTop: '12px',
                display: 'flex',
                gap: '8px',
                alignItems: 'flex-start'
              }}>
                <FaExclamationTriangle style={{ color: '#856404', marginTop: '2px', flexShrink: 0 }} />
                <span style={{ color: '#856404', fontSize: '14px' }}>
                  Esta acción eliminará la referencia de progresión desde otras membresías que 
                  apuntan a esta.
                </span>
              </div>
            )}
            <p style={{ marginTop: '12px', fontSize: '14px', color: '#6c757d' }}>
              Esta acción no se puede deshacer.
            </p>
          </div>
        ) : (
          <div>
            <div className="error-box" style={{ 
              background: '#f8d7da', 
              padding: '12px', 
              borderRadius: '8px',
              display: 'flex',
              gap: '8px',
              alignItems: 'flex-start'
            }}>
              <FaExclamationTriangle style={{ color: '#721c24', marginTop: '2px', flexShrink: 0 }} />
              <div style={{ color: '#721c24' }}>
                <strong>No se puede eliminar esta membresía</strong>
                <p style={{ margin: '8px 0 0 0', fontSize: '14px' }}>
                  Actualmente hay <strong>{membership.client_count} cliente{membership.client_count !== 1 ? 's' : ''}</strong> asignado{membership.client_count !== 1 ? 's' : ''} a esta membresía.
                </p>
              </div>
            </div>
            <p style={{ marginTop: '12px', fontSize: '14px', color: '#6c757d' }}>
              Por favor, reasigna todos los clientes a otra membresía antes de eliminarla.
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleClose}>
          {canDelete ? 'Cancelar' : 'Cerrar'}
        </button>
        {canDelete && (
          <button className="btn btn-danger" onClick={onConfirm}>
            Eliminar
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteMembership;
